import { autoserialize } from 'cerialize';

export class AutoCompleteResult {
  @autoserialize
  locationId: string;

  @autoserialize
  mainText: string;

  @autoserialize
  secondaryText: string;

  @autoserialize
  label: string;

  @autoserialize
  streetAddress: string;

  @autoserialize
  city: string;

  @autoserialize
  country: string;

  @autoserialize
  countryCode: string;

  @autoserialize
  language: string;

  @autoserialize
  county: string;

  @autoserialize
  district: string;

  @autoserialize
  postalCode: string;

  @autoserialize
  state: string;
}
